module.exports = __webpack_public_path__ + "static/media/dispensing_vector_small.2e627f5c.png";